import {styled} from "@mui/material";

export const DeliveryAddressSelectorContainer = styled('div')(() => ({
}));

export const DeliveryAddressContainer = styled('div')(({theme}) => ({
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    gap: '1rem',
    padding: '0.5rem 1rem',
    borderRadius: '0.5rem',
    cursor: 'pointer',

    '&:hover': {
        background: theme.barekam.grey
    }
}));

export const DeliveryAddressContainerSelected = styled(DeliveryAddressContainer)(({theme}) => ({
    border: `0.15rem solid ${theme.barekam.green}`,
    padding: '0.35rem 0.90rem',
}));

export const DeliveryAddressTextContainer = styled('div')(({}) => ({
    display: 'flex',
    flexDirection: 'column'
}));


